export default __webpack_public_path__ + "static/media/linkWell1.da18361b.png";